import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface SecurityRow {
  readonly securityEventId: string;
  readonly eventType: string;
  readonly severity: string;
  readonly status: string;
  readonly alertGenerated: boolean;
}

export function M19SecurityDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<SecurityRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: SecurityRow[] }>('/v1/platform/security-events', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.security.loading')}</p>;
  return (
    <main aria-label="security-dashboard">
      <h1>{t('m19.security.title')}</h1>
      <table aria-label="security-events-table">
        <thead><tr><th>{t('m19.security.colEvent')}</th><th>{t('m19.security.colSeverity')}</th><th>{t('m19.security.colStatus')}</th><th>{t('m19.security.colAlert')}</th></tr></thead>
        <tbody>
          {rows.map((s) => (
            <tr key={s.securityEventId}>
              <td>{s.eventType}</td>
              <td>{s.severity}</td>
              <td>{s.status}</td>
              <td>{s.alertGenerated ? t('m19.security.yes') : t('m19.security.no')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
